import React, { useEffect, useState } from 'react'
import ModalTest from '../../../../components/BaseModal'
import { DocumentContainer, Table, TableCell, TableHeader, TableHeaderCell, TableRow } from './style'
import { useParams } from 'react-router-dom'
import { OrderType } from '../AddOrder'
import axios from 'axios'
import { OrderProduct } from '../AddOrder/OrderSections/Product'

interface LabelAndValues {
  value: keyof OrderProduct
  label: string
  width: string | undefined
}

const ViewSteelOrder = () => {
  const [ order, setOrder ] = useState<OrderType | null>(null)
  const { orderId } = useParams()
  
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_STEEL_ORDERS_BASE_URL}/order/${orderId}`)
      .then(response => {
        if(response.data) setOrder(response.data)
      })
      .catch(error => console.error(error))
  }, [])

  console.log(order)
  
  const headers:LabelAndValues[] = [
    { value: 'product', label: 'Produto', width: undefined },
    { value: 'quantity', label: 'Qtd.', width: '64px' },
    { value: 'diameter', label: 'Diam.', width: '64px' },
    { value: 'weigth', label: 'Peso total (est.)', width: '110px' },
    { value: 'thickness', label: 'Esp.', width: '64px' },
    { value: 'length', label: 'Compr.', width: '63px' },
  ]
  
  return (
    <ModalTest>
      <DocumentContainer>
        <div>
          <h4>Número do pedido: {order?.id}</h4>
          <span>Vendedor: {order?.seller}</span>
        </div>
        <div>
          <label>Cliente pediu</label>
          <Table>
            <TableHeader>
              <tr>
                {headers.map((header) => (
                  <TableHeaderCell key={header.value} width={header.width}>
                    {header.label}
                  </TableHeaderCell>
                ))}
              </tr>
            </TableHeader>
            <tbody>
            {order?.items.map((product, index) => (
              <TableRow key={index}>
                {headers.map((header, i) => (
                  <TableCell
                    key={i}
                    width={header.width}
                  >
                    {product.requestedProduct[header.value]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
            </tbody>
          </Table>
        </div>

        <div>
          <label>Nós vendemos</label>
          <Table>
            <TableHeader>
              <tr>
                {headers.map((header) => (
                  <TableHeaderCell key={header.value} width={header.width}>
                    {header.label}
                  </TableHeaderCell>
                ))}
              </tr>
            </TableHeader>
            <tbody>
            {order?.items.map((product, index) => (
              <TableRow key={index}>
                {headers.map((header, i) => (
                  <TableCell
                    key={i}
                    width={header.width}
                  >
                    {product.offeredProduct[header.value]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
            </tbody>
          </Table>
        </div>
        versão dev
      </DocumentContainer>
    </ModalTest>
  )
}

export default ViewSteelOrder